// const pickupTimes: any = [
//   {
//     code: 'MM',
//     times: ['06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00']
//   },
//   {
//     code: 'CR',
//     times: ['05:10', '05:20', '05:30', '05:40', '05:50', '06:00', '06:10', '06:20', '06:30', '07:20', '07:40',
//     '08:10', '08:15', '08:20', '08:25', '08:30', '08:40', '08:50', '09:00',  '09:10', '09:15', '09:20', '09:30',
//     '10:10', '10:20', '10:30', '10:40', '10:45', '10:50', '10:55', '11:00', '11:10', '11:20', '11:30', '11:40',
//     '11:50', '13:20', '13:40']
//   }
// ];

// const parks: any = [
//   {
//     code: 'mm',
//     headerColor: '#acc74e',
//     pickupTimes: pickupTimes[0].times
//   },
//   {
//     code: 'cra',
//     headerColor: '#006400',
//     pickupTimes: pickupTimes[1].times
//   },
//   {
//     code: 'crp',
//     headerColor: '#fd7221',
//     pickupTimes: pickupTimes[1].times
//   },
//   {
//     code: 'sm',
//     headerColor: '#acc74e',
//   }
// ];

const parks = [
  {
    code: 'jam',
    headerColor: '#acc74e',
    logo: 'assets/img/mm-logo.png',
    cut: 'assets/img/bobsled2cut.jpg'
  },
  {
    code: 'sxm',
    headerColor: '#acc74e',
    logo: 'assets/img/logo_rfa.png',
    cut: 'assets/img/fondo_flying_RFA.jpg'
  },
  {
    code: 'slu',
    headerColor: '#FFDB58',
    logo: 'assets/img/slu_logo.png',
    cut: 'assets/img/slu_background.png'
  },
  {
    code: 'cra',
    headerColor: '#006400',
    headerText: 'BRAULIO CARRILLO - ATLANTICO',
    logo: 'assets/img/cr-logo.png',
    cut: 'assets/img/cra-background.jpg'
  },
  {
    code: 'crp',
    headerColor: '#fd7221',
    headerText: 'JACO BEACH - PACIFICO',
    logo: 'assets/img/cr-logo.png',
    cut: 'assets/img/crp-background.jpg'
  },
  {
    code: 'intercarib',
    headerColor: '#3D8AF7',
    logo: 'assets/img/logo_rfa.png',
    cut: 'assets/img/seatrek.png'
  }
]

export const config: any = {

  defaultLocale: 'us',
  currentPark: parks[5], // parks[0] JAM | parks[1] SXM | parks[2] SLU | parks[3] CRA | parks[4] CRP
  parksWithDisabledAdminRoutes: ['cra', 'crp'], // Arreglo de parques (atributo code) que no tienen acceso a las rutas de: POS Manager, Reports (POS Invoices y POS Invoices Details), Billing e Invoices
  API_URL: 'assets/api',
    WAIVER_URL: 'https://dev.rfa.binwus.com/appwaiver/api/v1',
  URL: '/app/api/v1',
  // URL: 'http://localhost:3000/api/v1',
  // URL: 'http://172.16.1.2/app/api/v1',
  // tslint:disable-next-line:max-line-length
  gatemasterIntegration: false,
  API_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXkiOiJjODkzYmFkNjg5MjdiNDU3ZGJlZDM5NDYwZTZhZmQ2MiIsImlhdCI6MTUzMDA0MzYwOH0.QXDWjJGgD1_QP0wUoEZ-_aNwFgq5M3al1g-GKAS70Po',
  menu_speed: 200,
  smartSkin: 'smart-style-0',

  oauth: {
    kid: 'Tqf/kumyu7HC6ORi0Dz0XGBYxjukRuHVd1u/V/tJx9I',
    iss: 'https://api.waiver.com', // Identifier of the authentication server
    jwks: 'https://dev.waiver.binwus.com/.well-known/jwks.json',
    clientId: 'DH65dHoDu9ApHXjzV6KcqFwbGs5QrjX8RPAK4bgGJU', // Application Client ID for this api
    clientSecret: 'LdYyXHuwKXrARViMLR9hmHzprsp22ToPcuVwCKpgVDU', // Application Client Secret for this api
    serverTokenUrl: 'https://dev.rfa.binwus.com/appwaiver/api/v1/oauth/token', // Authentication server endpoint
  },
  appConfig: {
    'auto': false,
    'invitation': true
  },

  skins: [
    {
      id: 0,
      name: 'smart-style-0',
      logo: 'assets/img/logo.png',
      skinBtnClass: 'btn btn-block btn-xs txt-color-white margin-right-5 profile-theme-btn',
      style: {
        backgroundColor: '#4E463F'
      },
      label: 'Smart Default'
    },

    {
      id: 1,
      name: 'smart-style-1',
      logo: 'assets/img/logorfa.png',
      skinBtnClass: 'btn btn-block btn-xs txt-color-white profile-theme-btn',
      style: {
        background: '#3A4558'
      },
      label: 'Dark Elegance'
    },

    {
      id: 2,
      name: 'smart-style-2',
      logo: 'assets/img/logorfa.png',
      skinBtnClass: 'btn btn-xs btn-block txt-color-darken margin-top-5 profile-theme-btn',
      style: {
        background: '#fff'
      },
      label: 'Ultra Light'
    },

    {
      id: 3,
      name: 'smart-style-3',
      logo: 'assets/img/logo.png',
      skinBtnClass: 'btn btn-xs btn-block txt-color-white margin-top-5 profile-theme-btn',
      style: {
        background: '#f78c40'
      },
      label: 'Google Skin'
    },

    {
      id: 4,
      name: 'smart-style-4',
      logo: 'assets/img/logo.png',
      skinBtnClass: 'btn btn-xs btn-block txt-color-white margin-top-5 profile-theme-btn',
      style: {
        background: '#bbc0cf',
        border: '1px solid #59779E',
        color: '#17273D !important'
      },
      label: 'PixelSmash'
    },

    {
      id: 5,
      name: 'smart-style-5',
      logo: 'assets/img/logo.png',
      skinBtnClass: 'btn btn-xs btn-block txt-color-darken margin-top-5 profile-theme-btn',
      style: {
        background: 'rgba(153, 179, 204, 0.2)',
        border: '1px solid rgba(121, 161, 221, 0.8)',
        color: '#17273D !important'
      },
      label: 'Glass'
    },


  ],

  GOOGLE_API_KEY: 'AIzaSyDd8YW8k_J-Jkti-W4QNk5dL8O_5_2QUWY',

  sound_path: 'assets/sound/',
  sound_on: true,


  /**
   * DEBUGGING MODE
   * debugState = true; will spit all debuging message inside browser console.
   * The colors are best displayed in chrome browser.
   */

  debugState: false,
  debugStyle: 'font-weight: bold; color: #00f;',
  debugStyle_green: 'font-weight: bold; font-style:italic; color: #46C246;',
  debugStyle_red: 'font-weight: bold; color: #ed1c24;',
  debugStyle_warning: 'background-color:yellow',
  debugStyle_success: 'background-color:green; font-weight:bold; color:#fff;',
  debugStyle_error: 'background-color:#ed1c24; font-weight:bold; color:#fff;',


  /**
   *  VOICE CONTROL
   */
  voice_command: true,
  voice_command_auto: false,


  /**
   *  Sets the language to the default 'en-US'. (supports over 50 languages
   *  by google)
   *
   *  Afrikaans         ['af-ZA']
   *  Bahasa Indonesia  ['id-ID']
   *  Bahasa Melayu     ['ms-MY']
   *  CatalГ            ['ca-ES']
   *  ДЊeЕЎtina         ['cs-CZ']
   *  Deutsch           ['de-DE']
   *  English           ['en-AU', 'Australia']
   *                    ['en-CA', 'Canada']
   *                    ['en-IN', 'India']
   *                    ['en-NZ', 'New Zealand']
   *                    ['en-ZA', 'South Africa']
   *                    ['en-GB', 'United Kingdom']
   *                    ['en-US', 'United States']
   *  EspaГ±ol          ['es-AR', 'Argentina']
   *                    ['es-BO', 'Bolivia']
   *                    ['es-CL', 'Chile']
   *                    ['es-CO', 'Colombia']
   *                    ['es-CR', 'Costa Rica']
   *                    ['es-EC', 'Ecuador']
   *                    ['es-SV', 'El Salvador']
   *                    ['es-ES', 'EspaГ±a']
   *                    ['es-US', 'Estados Unidos']
   *                    ['es-GT', 'Guatemala']
   *                    ['es-HN', 'Honduras']
   *                    ['es-MX', 'MГ©xico']
   *                    ['es-NI', 'Nicaragua']
   *                    ['es-PA', 'PanamГЎ']
   *                    ['es-PY', 'Paraguay']
   *                    ['es-PE', 'PerГє']
   *                    ['es-PR', 'Puerto Rico']
   *                    ['es-DO', 'RepГєblica Dominicana']
   *                    ['es-UY', 'Uruguay']
   *                    ['es-VE', 'Venezuela']
   *  Euskara           ['eu-ES']
   *  FranГ§ais         ['fr-FR']
   *  Galego            ['gl-ES']
   *  Hrvatski          ['hr_HR']
   *  IsiZulu           ['zu-ZA']
   *  ГЌslenska         ['is-IS']
   *  Italiano          ['it-IT', 'Italia']
   *                    ['it-CH', 'Svizzera']
   *  Magyar            ['hu-HU']
   *  Nederlands        ['nl-NL']
   *  Norsk bokmГҐl     ['nb-NO']
   *  Polski            ['pl-PL']
   *  PortuguГЄs        ['pt-BR', 'Brasil']
   *                    ['pt-PT', 'Portugal']
   *  RomГўnДѓ          ['ro-RO']
   *  SlovenДЌina       ['sk-SK']
   *  Suomi             ['fi-FI']
   *  Svenska           ['sv-SE']
   *  TГјrkГ§e          ['tr-TR']
   *  Р±СЉР»РіР°СЂСЃРєРё['bg-BG']
   *  PСѓСЃСЃРєРёР№     ['ru-RU']
   *  РЎСЂРїСЃРєРё      ['sr-RS']
   *  н•њкµ­м–ґ         ['ko-KR']
   *  дё­ж–‡            ['cmn-Hans-CN', 'ж™®йЂљиЇќ (дё­е›Ѕе¤§й™†)']
   *                    ['cmn-Hans-HK', 'ж™®йЂљиЇќ (й¦™жёЇ)']
   *                    ['cmn-Hant-TW', 'дё­ж–‡ (еЏ°зЃЈ)']
   *                    ['yue-Hant-HK', 'зІµиЄћ (й¦™жёЇ)']
   *  ж—Ґжњ¬иЄћ         ['ja-JP']
   *  Lingua latД«na    ['la']
   */
  voice_command_lang: 'en-US',
  /**
   *  Use localstorage to remember on/off (best used with HTML Version)
   */
  voice_localStorage: false,
  /**
   * Voice Commands
   * Defines all voice command variables and functions
   */

  voice_commands: {

    'show dashboard': {
      type: 'navigate', payload: ['/dashboard/+analytics']
    },
    'show +social': {
      type: 'navigate', payload: ['/dashboard/+social']
    },
    'show outlook': {
      type: 'navigate', payload: ['/outlook']
    },
    'show graphs': {
      type: 'navigate', payload: ['/graphs/chart-js']
    },
    'show flot chart': {
      type: 'navigate', payload: ['/graphs/flot-charts']
    },
    'show morris chart': {
      type: 'navigate', payload: ['/graphs/morris-charts']
    },
    'show inline chart': {
      type: 'navigate', payload: ['/graphs/sparklines']
    },
    'show dygraphs': {
      type: 'navigate', payload: ['/graphs/dygraphs']
    },
    'show tables': {
      type: 'navigate', payload: ['/tables/normal']
    },
    'show data table': {
      type: 'navigate', payload: ['/tables/datatables']
    },
    'show form': {
      type: 'navigate', payload: ['/forms/elements']
    },
    'show form layouts': {
      type: 'navigate', payload: ['/forms/layouts']
    },
    'show form validation': {
      type: 'navigate', payload: ['/forms/validation']
    },
    'show form elements': {
      type: 'navigate', payload: ['/forms/bootstrap-elements']
    },
    'show form plugins': {
      type: 'navigate', payload: ['/forms/plugins']
    },
    'show form wizards': {
      type: 'navigate', payload: ['/forms/wizards']
    },
    'show bootstrap editor': {
      type: 'navigate', payload: ['/forms/editors']
    },
    'show dropzone': {
      type: 'navigate', payload: ['/forms/dropzone']
    },
    'show image cropping': {
      type: 'navigate', payload: ['/forms/image-cropping']
    },
    'show general elements': {
      type: 'navigate', payload: ['/ui/general-elements']
    },
    'show buttons': {
      type: 'navigate', payload: ['/ui/buttons']
    },
    'show fontawesome': {
      type: 'navigate', payload: ['/ui/icons/font-awesome']
    },
    'show glyph icons': {
      type: 'navigate', payload: ['/ui/icons/glyphicons']
    },
    'show flags': {
      type: 'navigate', payload: ['/ui/icons/flags']
    },
    'show grid': {
      type: 'navigate', payload: ['/ui/grid']
    },
    'show tree view': {
      type: 'navigate', payload: ['/ui/treeviews']
    },
    'show nestable lists': {
      type: 'navigate', payload: ['/ui/nestable-lists']
    },
    'show jquery U I': {
      type: 'navigate', payload: ['/ui/jquery-ui']
    },
    'show typography': {
      type: 'navigate', payload: ['/ui/typography']
    },
    'show calendar': {
      type: 'navigate', payload: ['/calendar']
    },
    'show widgets': {
      type: 'navigate', payload: ['/widgets']
    },
    'show gallery': {
      type: 'navigate', payload: ['/app-views/gallery']
    },
    'show maps': {
      type: 'navigate', payload: ['/maps']
    },
    'go back': (): any => {
      history.back();
    },
    'scroll up': (): any => {
      jQuery('html, body').animate({scrollTop: 0}, 100);
    },
    'scroll down': (): any => {
      jQuery('html, body').animate({scrollTop: jQuery(document).height()}, 100);
    },
    'hide navigation': {
      type: 'layout',
      payload: 'hide navigation'
    },
    'show navigation': {
      type: 'layout',
      payload: 'show navigation'
    },
    'mute': {
      type: 'sound',
      payload: 'mute',
    },
    'sound on': {
      type: 'sound',
      payload: 'sound on',
    },
    'stop': {
      type: 'voice',
      payload: 'stop'
    },
    'help': {
      type: 'voice',
      payload: 'help on'
    },
    'got it': {
      type: 'voice',
      payload: 'help off'
    },
    'logout': {
      type: 'navigate',
      payload: ['/auth/login'],
    },
  }
};


// required for SmartNotification
window['jQuery'].sound_on = config.sound_on;
window['jQuery'].sound_path = config.sound_path;



// WEBPACK FOOTER //
// ./src/app/shared/smartadmin.config.ts